import { useMutation, useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { UserData } from './types';
import { updateCurrentUser } from './api';

const useUpdateCurrentUser = () => {
    const queryClient = useQueryClient();
    const { mutate } = useMutation(updateCurrentUser, {
        onMutate: async (variables: {
            eventId: number;
            userProfileId: number;
            payload: Partial<UserData>;
        }) => {
            await queryClient.cancelQueries('currentUser');
            const previousCurrentUser = queryClient.getQueryData<UserData>('currentUser');
            queryClient.setQueryData<UserData>('currentUser', state => ({
                ...state,
                ...variables.payload,
            }));

            return { previousCurrentUser };
        },
        onError: (_error, _variables, context) => {
            queryClient.setQueryData('currentUser', context.previousCurrentUser);
        },
        onSettled: () => {
            queryClient.invalidateQueries('currentUser');
        },
    });

    return useCallback(mutate, []);
};

export default useUpdateCurrentUser;
